import React from 'react'

import styles from './TideGraphLegend.module.css'
import iconHigh from '../../assets/images/icon-average-high-tide.svg'
import iconLow from '../../assets/images/icon-average-low-tide.svg'

export default ({tideHeightRange}) => {
  const { min, max } = tideHeightRange
  const minMaxDiff   = max - min
  const fakeMHHW     = (max - minMaxDiff * 0.15).toFixed(1)

  return (
    <div className={styles.container}>
      <div className={styles.item}>
      <img className={styles.icon} src={iconHigh} />&nbsp;
        Average high is
        <span className={styles.height}> {fakeMHHW} ft.</span>
      </div> <div className={styles.item}>
        <img className={styles.icon} src={iconLow} />&nbsp;
        Average low is
        <span className={styles.height}> 0 ft.</span>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/DayPage/TideGraphLegend.js